import { BOX, LINE, POLYGON } from 'client/utils/constants/symbolName';

// Domain-level draw intent names (distinct from geometry/symbol names).
export const DRAW_TYPES = Object.freeze({
    AREA_BOX: 'AreaBox',
    CUSTOM_POLYGON: 'CustomPolygon',
    LINEAR_SEARCH: 'LinearSearch'
});

export const DRAW_TYPE_TO_SYMBOL_NAME = Object.freeze({
    [DRAW_TYPES.AREA_BOX]: BOX,
    [DRAW_TYPES.CUSTOM_POLYGON]: POLYGON,
    [DRAW_TYPES.LINEAR_SEARCH]: LINE
});

export const SYMBOL_NAME_TO_DRAW_TYPE = Object.freeze({
    [BOX]: DRAW_TYPES.AREA_BOX,
    [POLYGON]: DRAW_TYPES.CUSTOM_POLYGON,
    [LINE]: DRAW_TYPES.LINEAR_SEARCH
});

export const toDrawType = (symbolName) => SYMBOL_NAME_TO_DRAW_TYPE[symbolName] || null;

export const toSymbolName = (drawType) => DRAW_TYPE_TO_SYMBOL_NAME[drawType] || null;

export const isLinearSearchDrawType = (drawType) => drawType === DRAW_TYPES.LINEAR_SEARCH;

export const isCustomPolygonDrawType = (drawType) => drawType === DRAW_TYPES.CUSTOM_POLYGON;

export const isAreaBoxDrawType = (drawType) => drawType === DRAW_TYPES.AREA_BOX;
